module.exports = __webpack_public_path__ + "static/media/cancel.e75ae41f.svg";